import { render, staticRenderFns } from "./green.vue?vue&type=template&id=16bdc7c3"
import script from "./green.vue?vue&type=script&lang=js"
export * from "./green.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports